import Cookies from 'js-cookie';
import { useCallback, useMemo } from 'react';

import { useTenant } from '../context/TenantContext';

const useCookie = () => {
  const isDevelopment = process.env.NODE_ENV === 'development';
  const { env } = useTenant();

  const defaultConfig = useMemo(
    () => ({
      path: '/',
      domain: env.REACT_APP_SUB_DOMAIN,
    }),
    [env.REACT_APP_SUB_DOMAIN],
  );

  const setCookie = useCallback(
    (name, value, config) => {
      if (isDevelopment) Cookies.set(name, value);
      else
        Cookies.set(name, value, {
          ...defaultConfig,
          ...config,
        });
    },
    [defaultConfig, isDevelopment],
  );

  const getCookie = useCallback((name) => {
    if (name) return Cookies.get(name);

    return Cookies.get();
  }, []);

  const removeCookie = useCallback(
    (name, config) => {
      if (isDevelopment) Cookies.remove(name);
      else
        Cookies.remove(name, {
          ...defaultConfig,
          ...config,
        });
    },
    [defaultConfig, isDevelopment],
  );

  return { setCookie, getCookie, removeCookie };
};

export default useCookie;
